import * as Uom from '@/services/rest-api/lib/product/unit-of-measurement'

const uomFields = [
  {
    key: 'uom',
    name: 'uom',
    label: 'Satuan Dasar',
    placeholder: 'Satuan Dasar',
    tooltip: 'Satuan dasar merupakan satuan terkecil dari produk Anda.',
    type: 'select-resourceful',
    trackBy: 'name',
    optionsGetter: Uom.get,
    optionLabelFn: ({ item }) => item.name,
    initialObjectKey: 'uom',
    validation: 'bail|required',
  },
  {
    key: 'weight',
    name: 'weight',
    label: 'Berat Produk',
    placeholder: 'Berat Produk',
    _type: 'number',
    suffix: 'Kg',
    validation: 'bail|number|max:1000000,value|not:0',
    'validation-messages': {
      number: 'Harus berupa angka',
      max: 'Maksimal 1,000,000',
      not: 'Harus lebih dari 0',
    },
  },
  {
    key: 'volume',
    name: 'volume',
    label: 'Volume Produk',
    placeholder: 'Volume Produk',
    _type: 'number',
    suffix: 'Cbm',
    validation: 'bail|number|max:1000000,value|not:0',
    'validation-messages': {
      number: 'Harus berupa angka',
      max: 'Maksimal 1,000,000',
      not: 'Harus lebih dari 0',
    },
  },
  {
    key: 'price',
    name: 'price',
    label: 'Harga Standar Produk (Rp)',
    placeholder: 'Harga Standar Produk (Rp)',
    _type: 'number',
    validation: 'bail|number|max:1000000000000,value|not:0',
    'validation-messages': {
      number: 'Harus berupa angka',
      max: 'Maksimal Rp. 1,000,000,000,000',
      not: 'Minimal Rp. 1',
    },
  },
]

export default uomFields
